import { render, staticRenderFns } from "./zTextarea.vue?vue&type=template&id=fb62ad94&scoped=true&"
import script from "./zTextarea.vue?vue&type=script&lang=js&"
export * from "./zTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb62ad94",
  null
  
)

export default component.exports